(() => {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready='true';
    const copy=JSON.parse(root.querySelector('[data-jesenska-copy]').textContent);
    const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'sl-SI',{style:'currency',currency:root.dataset.currency||'EUR'}).format(cents/100);
    const selected=new Map();
    const inputs=[...root.querySelectorAll('[data-select-product]')];
    const panel=root.querySelector('[data-selection]');
    const selectionDetails=panel.querySelector('[data-selection-details]');
    const reviewButton=panel.querySelector('[data-review-selection]');
    const message=root.querySelector('[data-cart-message]');
    const cards=[...root.querySelectorAll('[data-product-card]')];
    const heroForm=root.querySelector('.jo-hero [data-buy-form]');
    const mobileBuy=root.querySelector('[data-mobile-buy]');
    const storageKey='holistic:jesenska-osnova:selection:2026';
    let inFlight=false,offer=root.dataset.mode==='preview',lastAnnouncement='';
    const track=(action,detail)=>document.dispatchEvent(new CustomEvent('holistic:campaign',{detail:{campaign:'jesenska_osnova_2026',action,...detail}}));
    const showMessage=text=>{message.querySelector('[data-cart-message-text]').textContent=text;message.hidden=false;};
    const priceFor=item=>Number(item.dataset[offer?'sale':'regular']);
    function persist(){try{sessionStorage.setItem(storageKey,JSON.stringify([...selected.keys()]));}catch(_){}}
    function setReview(expanded){
      selectionDetails.hidden=!expanded;reviewButton.setAttribute('aria-expanded',String(expanded));
      reviewButton.textContent=copy[expanded?'collapse':'review'];
    }
    function updateSelection(announce=false){
      panel.hidden=selected.size===0;root.classList.toggle('has-selection',selected.size>0);
      const title=copy.selection.replace('{count}',selected.size);
      const total=[...selected.values()].reduce((sum,item)=>sum+priceFor(item),0);
      panel.querySelector('[data-selection-title]').textContent=title;
      panel.querySelector('[data-selection-total]').textContent=money(total);
      panel.querySelector('[data-selection-shipping]').textContent=total>Number(root.dataset.threshold)?copy.shippingMet:copy.shipping.replace('{threshold}',money(Number(root.dataset.threshold)));
      const handles=[...selected.values()].map(item=>item.dataset.handle);
      const overlap=handles.includes('b-kompleks-v-tekocini')&&handles.includes('vitamin-b12-v-tekocini');
      panel.querySelector('[data-overlap]').hidden=!overlap;panel.querySelector('[data-overlap-short]').hidden=!overlap;
      panel.querySelector('[data-add-selection]').disabled=inFlight||selected.size===0;
      const list=panel.querySelector('[data-selection-list]');list.replaceChildren();
      selected.forEach((item,id)=>{
        const row=document.createElement('li');
        const name=document.createElement('span');name.textContent=item.dataset.title;
        const price=document.createElement('strong');price.textContent=money(priceFor(item));
        const remove=document.createElement('button');remove.type='button';remove.className='jo-remove';
        remove.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
        remove.setAttribute('aria-label',copy.remove.replace('{product}',item.dataset.title));
        remove.addEventListener('click',()=>{
          selected.delete(id);inputs.filter(input=>input.value===id).forEach(input=>{input.checked=false;input.closest('.jo-item').classList.remove('is-selected');});
          persist();updateSelection(true);if(selected.size)reviewButton.focus();else inputs.find(input=>!input.disabled)?.focus();
        });
        row.append(name,price,remove);list.append(row);
      });
      if(!selected.size)setReview(false);
      const announcement=selected.size?title+', '+money(total):copy.empty;
      if(announce&&announcement!==lastAnnouncement)root.querySelector('[data-selection-status]').textContent=announcement;
      lastAnnouncement=announcement;
    }
    function syncOffer(){
      const now=Date.now();
      offer=root.dataset.mode==='preview'||(root.dataset.mode==='live'&&now>=Date.parse(root.dataset.start)&&now<=Date.parse(root.dataset.end));
      root.querySelectorAll('[data-offer-only]').forEach(el=>{el.hidden=!offer;});
      root.querySelectorAll('[data-regular-only]').forEach(el=>{el.hidden=offer;});
      root.querySelectorAll('[data-current-price]').forEach(el=>{el.textContent=money(Number(el.dataset[offer?'sale':'regular']));});
      root.classList.toggle('is-ended',!offer);updateSelection();
    }
    root.querySelectorAll('[data-selection-control]').forEach(el=>{el.hidden=false;});
    root.querySelector('[data-filters]').hidden=false;
    root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{
      const group=button.dataset.filter;
      root.querySelectorAll('[data-filter]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
      cards.forEach(card=>{card.hidden=group!=='all'&&card.dataset.group!==group;});
      const count=cards.filter(card=>!card.hidden).length;
      root.querySelector('[data-filter-status]').textContent=copy.results.replace('{count}',count);track('filter',{group,count});
    }));
    inputs.forEach(input=>input.addEventListener('change',()=>{
      const item=input.closest('.jo-item');
      if(input.checked)selected.set(item.dataset.variant,item);else selected.delete(item.dataset.variant);
      item.classList.toggle('is-selected',input.checked);persist();updateSelection(true);
      track('select',{handle:item.dataset.handle,selected:input.checked});
    }));
    panel.querySelector('[data-clear-selection]').addEventListener('click',()=>{
      selected.clear();inputs.forEach(input=>{input.checked=false;input.closest('.jo-item').classList.remove('is-selected');});persist();updateSelection(true);inputs.find(input=>!input.disabled)?.focus();
    });
    reviewButton.addEventListener('click',()=>setReview(selectionDetails.hidden));
    try{
      const saved=JSON.parse(sessionStorage.getItem(storageKey)||'[]');
      if(Array.isArray(saved))inputs.forEach(input=>{if(saved.includes(input.value)&&!input.disabled){input.checked=true;const item=input.closest('.jo-item');selected.set(input.value,item);item.classList.add('is-selected');}});
    }catch(_){}
    function openCart(){
      if(window.HolisticRapidCart?.open())return true;
      const opener=document.querySelector('#cart-icon');if(opener){opener.click();return true;}return false;
    }
    async function add(items,button,clearSelection){
      if(inFlight||!items.length)return;
      inFlight=true;const previous=button.innerHTML;
      button.textContent=copy.adding;button.setAttribute('aria-busy','true');
      const states=[...root.querySelectorAll('[data-add-button],[data-add-selection]')].map(el=>[el,el.disabled]);
      states.forEach(([el])=>{el.disabled=true;});message.hidden=true;
      let success=false;
      try{
        let response;
        try{response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Kaching-Cart-Ignore':'1'},body:JSON.stringify({items:items.map(item=>({id:Number(item.dataset.variant),quantity:1}))})});}
        catch(_){showMessage(copy.ambiguous);return;}
        let payload;try{payload=await response.json();}catch(_){showMessage(copy.ambiguous);return;}
        if(!payload){showMessage(copy.ambiguous);return;}
        if(!response.ok||payload.status){showMessage(payload.description||payload.message||copy.error);return;}
        success=true;
        if(window.HolisticRoutineDiscounts?.sync){try{await window.HolisticRoutineDiscounts.sync();}catch(_){}}
        showMessage(copy.added);openCart();
        track('add',{handles:items.map(item=>item.dataset.handle),quantity:items.length,source:button.closest('.jo-mobile-buy')?'mobile_bar':button.closest('.jo-close')?'page_end':clearSelection?'selection':'product'});
        if(clearSelection){selected.clear();inputs.forEach(input=>{input.checked=false;input.closest('.jo-item').classList.remove('is-selected');});persist();}
      }finally{
        inFlight=false;button.innerHTML=previous;button.removeAttribute('aria-busy');
        states.forEach(([el,disabled])=>{el.disabled=disabled;});updateSelection(true);
        if(!success)message.querySelector('[data-open-cart]').focus();
      }
    }
    root.querySelectorAll('[data-buy-form]').forEach(form=>form.addEventListener('submit',event=>{
      event.preventDefault();event.stopImmediatePropagation();add([form.closest('.jo-item')],event.submitter||form.querySelector('[data-add-button]'),false);
    },true));
    panel.querySelector('[data-add-selection]').addEventListener('click',event=>add([...selected.values()],event.currentTarget,true));
    root.querySelector('[data-open-cart]').addEventListener('click',event=>{if(openCart())event.preventDefault();});
    root.querySelector('[data-dismiss-message]').addEventListener('click',()=>{message.hidden=true;});
    const drawer=document.querySelector('#rapi-cart-drawer-panel');
    if(drawer){
      const syncDrawer=()=>{const visible=!drawer.hidden&&getComputedStyle(drawer).display!=='none';root.classList.toggle('is-cart-open',visible);if(visible)message.hidden=true;};
      new MutationObserver(syncDrawer).observe(drawer,{attributes:true,attributeFilter:['hidden','class','style','aria-hidden']});syncDrawer();
    }
    if(mobileBuy&&heroForm&&'IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>{mobileBuy.hidden=entries[0].boundingClientRect.bottom>=0;},{threshold:0});observer.observe(heroForm);
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))observer.disconnect();});
    }
    syncOffer();
    const interval=root.dataset.mode==='live'?setInterval(syncOffer,30000):null;
    if(interval)document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))clearInterval(interval);});
  }
  const boot=scope=>scope.querySelectorAll('[data-jesenska]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document),{once:true});else boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
